import {useEffect} from "react";
import {Link} from "react-router-dom";
import {Icon} from "../SVGsprite/svgsprite";
import styles from "./MyReceipts.module.scss";
import {Loader} from "../Loader/Loader";
import clsx from "clsx";
import {useActor, useMachine} from "@xstate/react";
import {myReceiptsMachine} from "../../xstate/myreceipts.machine";
import {Pagination} from "../Pagination/Pagination";
import {Banners} from "../Banners/Banners";
import {Bonuses} from "../Bonuses/Bonuses";
import {NoData} from "../NoData/NoData";
import {AuthState} from "../../xstate/auth.machine";

export function MyReceipts() {
    let [stateAuth] = useActor(AuthState);
    let [stateReceipts, sendReceipts] = useMachine(myReceiptsMachine);

    useEffect(()=>{console.log(stateAuth.context.can_upload)},[])

    useEffect(() => {
        document.title = "Мои чеки | Программа лояльности SK ZIC";
    }, []);

    return (
        <>
            <section className={styles.workarea}>
                <div className="titleBlock">
                    <h1>Мои чеки</h1>
                    {
                        stateAuth.context.can_upload &&
                        <Link to={"/account/upload"} className={"btn btnPrimary btnIcon"}>
                            <Icon name={"icon-add"} sizeW="24" sizeH="24"/>
                            Загрузить чек
                        </Link>
                    }
                </div>

                <div className={"statContainer"}>
                    {
                        stateReceipts.matches("loading")
                            ? <Loader/>
                            : <>
                                <ReceiptsTable data={stateReceipts.context.list}/>
                                {
                                    stateReceipts.context.list.length > 0 &&
                                    <Pagination
                                        pages={stateReceipts.context.pages}
                                        current_page={stateReceipts.context.current_page}
                                        send={sendReceipts}
                                    />
                                }
                            </>
                    }
                </div>
            </section>
            <aside className={styles.sidebar}>
                <Bonuses/>
                <Banners/>
            </aside>
        </>)
}

function ReceiptsTable(props) {

    if (props.data.length === 0) {
        return <NoData/>
    }

    return (
        <div className="scrollbox">
            <table className={"statTable"}>
                <thead>
                <tr>
                    <th>Дата и время продажи</th>
                    <th>Фото чека</th>
                    <th>ФД чека</th>
                    <th className={styles.status}>Статус</th>
                    <th>Баллы</th>
                </tr>
                </thead>
                <tbody>
                {
                    props.data.map(
                        (item) => {
                            return <tr key={item.id}>
                                <td>{item.date}</td>
                                <td>
                                    {
                                        (item.image !== "") &&
                                        <img src={item.image} alt=""/>
                                    }
                                </td>
                                <td>{item.fd}</td>
                                <td className={styles.status}>
                                    <span className={
                                        clsx(
                                            styles.stateValue,
                                            {
                                                [styles.stateDeclined]: item.status.state === "Отклонен",
                                                [styles.stateProcessing]: item.status.state === "В обработке",
                                                [styles.stateAccepted]: item.status.state === "Принят",
                                            }
                                        )
                                    }
                                    >
                                        {item.status.state}
                                    </span>
                                    {
                                        item.status.message.length > 0 &&
                                        <span className={styles.message}>
                                        {item.status.message}
                                    </span>
                                    }
                                </td>
                                <td>
                                    <span
                                        className={clsx(styles.flow, {
                                            [styles.stateDeclined]: item.status.state === "Отклонен",
                                            [styles.stateProcessing]: item.status.state === "В обработке",
                                            [styles.stateAccepted]: item.status.state === "Принят",
                                        })}
                                    >
                                        {item.flow}
                                    </span>
                                </td>
                            </tr>
                        }
                    )
                }
                </tbody>
            </table>
        </div>

    )
}